module.exports = __webpack_public_path__ + "img/header-diamondJewelry070Carat@2x.2ab5949.jpg";